import styled from "styled-components";

export const MainContent = styled.main`
    width: 100%;
`;
